import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiService } from './api.service';
import { map, catchError } from 'rxjs/operators';
import { UtilsService } from './utils.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(public service: ApiService, private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const utils = this.injector.get(UtilsService);

    // 👉 Skip auth if it's a presigned upload URL (e.g. contains AWS params)
    if (request.url.includes('X-Amz-Algorithm') || request.url.includes('s3.amazonaws.com') || request.url.includes('api.ipify.org')) {
      return next.handle(request); // No auth header
    }
   
    // 👉 Otherwise apply your normal logic
    let token = request.url.includes("odpay") ? this.service.getToken() : this.service.getODPayToken();
    
    // Robust fallback: if preferred token is missing, try the other one
    if (!token || token === 'null' || token === 'undefined') {
      token = this.service.getToken() || this.service.getODPayToken();
    }

    if (token && token !== 'null' && token !== 'undefined') {
    //  console.log(`[Interceptor] Adding Auth Header to ${request.url.substring(0, 50)}...`);
      request = request.clone({
        setHeaders: {
          Authorization: `${token}`,
          UserDetails:`${this.service.getUserDetails()}`
        }
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body && (event.body.status == 408 || event.body.code == 408)) {
            utils.errmsg({ status: 408 });
          }
        }
        return event;
      }),
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && error.status == 408) {
          utils.errmsg(error);
        }
        return throwError(error);
      })
    );
  }
}






